import React from "react";
import TabLayout from "../../helpers/TabLayout";
import EditableField from "../helpers/EditableField";
import { Stack } from "@mui/material";
import { sessionUpdate } from "../../../api/session";
import { useRouteLoaderData } from "react-router-dom";
import EditButtons from "../helpers/EditButtons";
import useEditObject from "../../../hooks/useEditObject";

const SocialsTab = () => {
  const loaderData = useRouteLoaderData("profileComponent");
  const userEntity = loaderData.userEntityRes?.data;
  const {
    editObject,
    isEditable,
    startEdit,
    stopEdit,
    editHandler: handleFieldChange,
  } = useEditObject();

  const fakeAccountName = `@${userEntity?.lastName?.length
    ? userEntity?.lastName?.trim().toLowerCase()
    : "doe"}.${userEntity?.firstName?.length ? userEntity?.firstName?.trim()
    .toLowerCase() : "john"}${userEntity?.phone?.trim().length >= 3
    ? userEntity?.phone?.substring(0, 3).toLowerCase()
    : "123"}`;

  const handleSave = async (event) => {
    event.preventDefault();
    const response = await sessionUpdate({
      ...userEntity,
      ...editObject.current,
    });
    if (response.code === "SUCCESS") {
      loaderData.userEntityRes.data = { ...userEntity, ...editObject.current };
    }
    stopEdit();
  };

  return (
    <TabLayout
      headerLabel="Social"
      skeletonLines={11}
    >
      <Stack
        component="form"
        onSubmit={handleSave}
        method="POST"
        height="100%"
        justifyContent="space-between"
      >
        <Stack spacing={4}>
          <EditableField
            label="LinkedIn"
            type="text"
            id="linkedinUserId"
            name="linkedinUserId"
            initialValue={userEntity?.linkedinUserId}
            placeholder={fakeAccountName}
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
          <EditableField
            label="Facebook"
            type="text"
            id="facebookUserId"
            name="facebookUserId"
            initialValue={userEntity?.facebookUserId}
            placeholder={fakeAccountName}
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
          <EditableField
            label="Gmail"
            type="text"
            id="gmailUserId"
            name="gmailUserId"
            initialValue={userEntity?.gmailUserId}
            placeholder={fakeAccountName}
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
          <EditableField
            label="Skype"
            type="text"
            id="skypeUserId"
            name="skypeUserId"
            initialValue={userEntity?.skypeUserId}
            placeholder={fakeAccountName}
            required={false}
            isEditable={isEditable}
            onChange={handleFieldChange}
          />
        </Stack>
        <EditButtons
          isEditable={isEditable}
          onUpdateClicked={startEdit}
          onSaveClicked={handleSave}
          onCancelClicked={stopEdit}
        />
      </Stack>
    </TabLayout>);
};

export default SocialsTab;